// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"depots_routeHeader_1bm7K","addButton":"depots_addButton_1xfZd"};